import React from 'react';
import { Button, Result, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import SlotOpsTimeSettingsPage from '../Pages/SlotOpsTimeSettingsPage';
import { useAppSelector } from '../Modules/Presentation/hooks';
import { selectUser } from '../Modules/User/Presentation/selectors';
import { canManageSlotOpsTimeSettings } from '../Utils/userPermissions';

const SlotOpsTimeSettingsRoutes = () => {
  const navigate = useNavigate();
  const currentUser = useAppSelector(selectUser);

  if (!currentUser) {
    return <Spin style={{ display: 'block', margin: '120px auto' }} />;
  }

  if (!canManageSlotOpsTimeSettings(currentUser)) {
    return (
      <Result
        status="403"
        title="접근 권한이 없습니다"
        subTitle="시간 제한 설정은 일반 관리자만 slot-manager-dashboard에서 변경할 수 있습니다."
        extra={(
          <Button
            type="primary"
            size="large"
            style={{ borderRadius: 6, padding: '0 32px' }}
            onClick={() => navigate('/')}
          >
            홈으로 이동
          </Button>
        )}
      />
    );
  }

  return <SlotOpsTimeSettingsPage />;
};

export default SlotOpsTimeSettingsRoutes;
